import { SearchNormal1 } from "iconsax-react";
import React, { forwardRef } from "react";

const FilterTextInput = forwardRef(
  ({ onChange, onKeyDown, placeholder, className, value }, ref) => {
    return (
      <div
        className={`${className} flex px-[12px] py-[11px] items-center gap-[8px] rounded-xl bg-white border border-[#EFF0F2] text-[14px]`}
      >
        <SearchNormal1 size="16" color="#C1C4CB" />
        <input
          type="text"
          placeholder={placeholder ?? "Search"}
          className="w-full font-normal outline-none"
          ref={ref}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
        />
      </div>
    );
  }
);

export default FilterTextInput;
